export const getCroppedImg = (imageSrc, croppedAreaPixels, cropType = "banner", targetWidth = 1200) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let aspectWidth, aspectHeight;

      if (cropType === "banner") {
        // ✅ Banner = 3:1 ratio
        aspectWidth = 3;
        aspectHeight = 1;
      } else {
        // ✅ Logo = 1:1 ratio
        aspectWidth = 1;
        aspectHeight = 1;
      }

      // Auto-calc height based on aspect ratio
      const targetHeight = Math.round(targetWidth * (aspectHeight / aspectWidth));

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          resolve(blob);
        },
        cropType === "banner" ? "image/jpeg" : "image/png",
        1
      );
    };

    image.onerror = (err) => reject(err);
  });
};
